import React, { useCallback, useEffect, useState } from "react";

const HandbookPdfViewer = ({ fileUrl, subject }) => {
  const [shieldActive, setShieldActive] = useState(false);

  useEffect(() => {
    const hideContent = () => setShieldActive(true);
    const showContent = () => setShieldActive(false);

    document.addEventListener("visibilitychange", hideContent);
    window.addEventListener("blur", hideContent);
    window.addEventListener("focus", showContent);

    return () => {
      document.removeEventListener("visibilitychange", hideContent);
      window.removeEventListener("blur", hideContent);
      window.removeEventListener("focus", showContent);
    };
  }, []);

  const preventDefault = useCallback((event) => {
    event.preventDefault();
  }, []);

  if (!fileUrl) {
    return (
      <div className="management_Handbook_Viewer_Empty">
        Select a handbook document to view
      </div>
    );
  }

  return (
    <div
      className="management_Handbook_Viewer"
      onContextMenu={preventDefault}
      onCopy={preventDefault}
      onCut={preventDefault}
    >
      {shieldActive && (
        <div
          className="management_Handbook_Viewer_Shield"
          aria-hidden="true"
        />
      )}
      <iframe
        title={subject || "HR Handbook"}
        src={`${fileUrl}#toolbar=0&navpanes=0`}
        className="management_Handbook_Viewer_Frame"
      />
    </div>
  );
};

export default HandbookPdfViewer;
